/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */

import React, { useState } from 'react';
import { Tooltip } from 'reactstrap';
import SpinnerCircles from '../../../Spinner/SpinerCircles';

const TooltipIcon = ({ tipId, onClick, imgSrc, displayData, placement, customClass, customStyle, loading, disabled }) => {
  const [portActivityOpen, setPortActivityOpen] = useState(false);
  const isDisabled = loading || disabled;

  const toggle = () => setPortActivityOpen(!portActivityOpen);

  const handleClick = () => {
    if (!isDisabled && onClick) onClick();
  };

  return (
    <>
      <span
        id={tipId}
        className={customClass ? customClass : 'analytics-icon'}
        onClick={handleClick}
        style={{
          cursor: isDisabled ? 'default' : 'pointer',
          opacity: disabled && !loading ? 0.7 : 1,
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          minWidth: loading ? '30px' : undefined,
          minHeight: loading ? '30px' : undefined,
        }}
      >
        {loading ? (
          <SpinnerCircles red />
        ) : (
          <img src={imgSrc} style={customStyle ? customStyle : { width: '30px' }} />
        )}
      </span>
      <Tooltip
        delay={0}
        placement={placement}
        isOpen={portActivityOpen}
        target={tipId}
        toggle={toggle}
        className={customClass || ''}
      >
        {displayData}
      </Tooltip>
    </>
  );
};

export default TooltipIcon;
